// extracted by mini-css-extract-plugin
export var sliderRange = "_mw-2";
export var sliderRoot = "_mw-0";
export var sliderThumb = "_mw-3";
export var sliderTrack = "_mw-1";